import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton from '@divvy-web/skylab.basicbutton'

import BasePageLayout from '@sputnik/pages/PostApplicationPages/CreditLineOffersPage/BasePageLayout'

import styles from './styles.module.scss'

const OfferAcceptedPage = () => {
  const [getClassName] = useNameFormatter('OfferAcceptedPage')

  return (
    <BasePageLayout
      footer={
        <BasicButton>
          <FormattedMessage
            defaultMessage='Close'
            id='sputnik.OfferAcceptedPage__rbrahO'
          />
        </BasicButton>
      }
      marketingImage={{
        src: '',
        alt: '',
      }}
    >
      <>
        <div className={styles[getClassName('title')]}>
          <FormattedMessage
            defaultMessage='Here’s what to expect next'
            id='sputnik.OfferAcceptedPage__68m4RK'
          />
        </div>
        <div className={styles[getClassName('subtitle')]}>
          <FormattedMessage
            defaultMessage='We’ll verify your identity and business information. This may take 3-5 days. If we need more information, we’ll email you. After you’re approved, your credit will be ready to use.'
            id='sputnik.OfferAcceptedPage__x/SHls'
          />
        </div>
      </>
    </BasePageLayout>
  )
}

export default OfferAcceptedPage
